import { useLocation } from "react-router";

type GetDeeplinkOptions = {
  remove?: boolean;
};

export const useDeeplink = () => {
  const location = useLocation();

  const saveDeeplink = (customPath?: string) => {
    const path = customPath ? customPath : location.pathname + location.search;
    window.storage.setItem("redirected_from", path);
  };

  const getDeeplink = (options: GetDeeplinkOptions) => {
    const deeplink = window.storage.getItem("redirected_from");
    if (options.remove) {
      window.storage.removeItem("redirected_from");
    }

    return deeplink;
  };

  return {
    getDeeplink,
    saveDeeplink
  };
};
